<ng-container *transloco="let t">
  <div
    id="forgot-password-card"
    class="bg-white rounded-2xl max-sm:rounded-b-none shadow-card max-sm:shadow-none w-full max-w-[480px] max-sm:max-w-full min-w-0 p-4 sm:p-10 max-xs:px-3"
  >
    <div id="forgot-password-header" class="flex flex-col items-center gap-2 mb-4">
      <img id="forgot-password-logo" [src]="logoUrl()" [alt]="partnerDisplayName()" class="h-14 w-auto" />
      <h1 id="forgot-password-title" class="text-section-heading text-ld-neutral-700 m-0">
        {{ title() || t('authForgotPasswordTitle') }}
      </h1>
    </div>

    <p id="forgot-password-subtitle" class="font-dm text-sm leading-5 text-ld-neutral-500 text-center m-0 mb-6">
      {{ subtitle() || t('authForgotPasswordSubtitle') }}
    </p>

    @if (errorMessage()) {
      <div
        id="forgot-password-error-message"
        class="bg-ld-error-light border border-ld-error rounded-lg px-4 py-3 mb-6 text-ld-error text-sm"
        role="alert"
      >
        {{ errorMessage() }}
      </div>
    }

    <form
      id="forgot-password-form"
      [formGroup]="forgotPasswordForm"
      (ngSubmit)="onSubmit()"
      class="flex flex-col gap-6"
    >
      <mat-form-field id="forgot-password-email-field" appearance="outline" class="w-full">
        <mat-label>{{ t('commonFieldsEmail') }}</mat-label>
        <input
          matInput
          id="forgot-password-email-input"
          type="email"
          formControlName="email"
          aria-required="true"
          (keydown.enter)="onEnterKey($event)"
        />
        @if (forgotPasswordForm.get('email')?.hasError('required')) {
          <mat-error id="forgot-password-email-error-required">{{ t('commonValidationEmailRequired') }}</mat-error>
        } @else if (forgotPasswordForm.get('email')?.hasError('nativeEmailError')) {
          <mat-error id="forgot-password-email-error-native">{{ t('commonValidationInvalidEmail') }}</mat-error>
        }
      </mat-form-field>

      <button
        type="submit"
        id="forgot-password-submit-button"
        class="btn-primary-ld-purple !order-none !w-full h-11 disabled:cursor-wait"
        [disabled]="loading()"
        [attr.aria-busy]="loading()"
      >
        @if (loading()) {
          <mat-spinner
            diameter="20"
            id="forgot-password-spinner"
            class="text-white! [&_circle]:stroke-white!"
          ></mat-spinner>
          <span>{{ t('authForgotPasswordSubmit') }}</span>
        } @else {
          <span>{{ t('authForgotPasswordSubmit') }}</span>
        }
      </button>

      <p id="forgot-password-footnote" class="font-dm text-xs leading-4 text-ld-neutral-500 text-center m-0">
        {{ t('authForgotPasswordFootnote') }}
      </p>

      <div id="forgot-password-back-link" class="flex items-center justify-center">
        <button
          type="button"
          id="forgot-password-back-button"
          (click)="onBackToLogin()"
          class="bg-transparent border-0 text-ld-link cursor-pointer p-0 font-dm text-sm font-medium leading-4 hover:underline focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded touch-target"
        >
          {{ t('commonLabelsBackToSignIn') }}
        </button>
      </div>
    </form>
  </div>
</ng-container>
